import styled from "@emotion/styled";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import useDownload from "../useDownload";

const DubbedHeader = ({ locale }: { locale: string }) => {
  const { t } = useTranslation();
  const { handleDownload } = useDownload();

  return (
    <Section>
      <Link href="/">
        <LogoImg />
      </Link>
      <DownloadButton onClick={() => handleDownload(locale)}>
        {t("button_download2dub")}
      </DownloadButton>
    </Section>
  );
};

const Section = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 400px;
  height: 44px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  background-color: black;
  align-items: center;
`;

const LogoImg = styled.div`
  width: 69px;
  height: 20px;
  background: url("/img/logo_white.png") no-repeat;
  background-size: cover;
`;

const DownloadButton = styled.button`
  min-width: 74px;
  min-height: 28px;
  padding: 5px 16px;
  background-color: var(--primary050);
  cursor: pointer;
  color: white;
  font-size: var(--fs-c1);
  line-height: var(--lh-c1);
  font-weight: 600;
  border-radius: 100px;
`;

export default DubbedHeader;
